export const BANNER_CONFIG = {
  ownerId: 262376,
  containerId: 'adfox_161718639132261405',
  params: {
    p1: 'conju',
    p2: 'hdml',
    pfc: 'deglt',
    pfb: 'jfqqq',
  },
};
